module.exports = __webpack_public_path__ + "img/point-3-v1.4ce1ff09.png";